const languageCodeToName = {
    'af': 'Afrikaans',
    'sq': 'shqiptare',
    'ar': 'عربى', 
    'hy': 'հայերեն', 
    'az': 'Azərbaycan', 
    'eu': 'euskara', 
    'be': 'беларуская', 
    'bg': 'български', 
    'ca': 'català', 
    'zh-CN': '简体中文）', 
    'zh-TW': '中國傳統的）', 
    'hr': 'Hrvatski', 
    'cs': 'čeština', 
    'da': 'dansk', 
    'nl': 'Nederlands', 
    'et': 'eesti keel', 
    'tl': 'Filipino', 
    'fi': 'Suomalainen', 
    'fr': 'français', 
    'gl': 'galego', 
    'ka': 'ქართული', 
    'de': 'Deutsch', 
    'el': 'Ελληνικά', 
    'ht': 'Kreyòl ayisyen', 
    'iw': 'עִברִית', 
    'hi': 'हिन्दी', 
    'hu': 'Magyar', 
    'is': 'íslenskur', 
    'id': 'bahasa Indonesia', 
    'ga': 'Gaeilge', 
    'it': 'italiano', 
    'ja': '日本', 
    'ko': '한국인', 
    'lv': 'latviski', 
    'lt': 'lietuvių', 
    'mk': 'македонски', 
    'ms': 'Melayu', 
    'mt': 'Malti', 
    'no': 'norsk', 
    'fa': 'فارسی', 
    'pl': 'polski', 
    'pt': 'Português', 
    'ro': 'Română', 
    'ru': 'русский', 
    'sr': 'Српски', 
    'sk': 'slovenský', 
    'sl': 'Slovenščina', 
    'es': 'español', 
    'sw': 'kiswahili', 
    'sv': 'svenska', 
    'th': 'ไทย', 
    'tr': 'Türkçe', 
    'uk': 'український', 
    'ur': 'اردو', 
    'vi': 'Tiếng Việt', 
    'cy': 'Cymraeg', 
    'yi': 'יידיש'
};

export default languageCodeToName;